'use strict';function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');let

FatigueDistributionIterableExtensions=function(){
function FatigueDistributionIterableExtensions(self){_classCallCheck(this,FatigueDistributionIterableExtensions);
this._self=self;
}FatigueDistributionIterableExtensions.prototype.

aggregate=function aggregate(fatigueDistributionParameters){
for(let fatigueDistribution of this._self){
fatigueDistributionParameters.checkDistributionsConformity(fatigueDistribution);
}

let aggregatedBins=[];
aggregatedBins.length=fatigueDistributionParameters.totalBins;

for(let i=0;i<aggregatedBins.length;i++){
aggregatedBins[i]=[];

for(let fatigueDistribution of this._self){
_.pushMany(aggregatedBins[i],fatigueDistribution.bins[i]);
}
}

return{
binSize:fatigueDistributionParameters.binSize,
start:fatigueDistributionParameters.firstBinStart,
bins:aggregatedBins};

};FatigueDistributionIterableExtensions.

extend=function extend(self){
return new FatigueDistributionIterableExtensions(self);
};return FatigueDistributionIterableExtensions}();


module.exports=FatigueDistributionIterableExtensions.extend;
//# sourceMappingURL=fatigueDistributionIterableExtensions.js.map
